/**
 * 작성자 : 박승호
 * 날짜 : 2025.12.08
 * 기능 : 파일 다운로드 함수
 */

import React from 'react';
import { downloadFile } from './flutterBridge';

export const fileDownloadFn = async (e: React.MouseEvent<HTMLButtonElement | HTMLSpanElement | HTMLDivElement | HTMLInputElement>, url: string) => {
  e.preventDefault();
  e.stopPropagation();

  if (!url) return null;

  try {
    return await downloadFile(url, url.split('/').pop() || 'thumbnail.jpg');
  } catch (error) {
    console.error('handleFileDownload error:', error);
    return null;
  }
};
